
export class TimestampTexts {

    static texts: { [key: string]: any} = {
        indice_pluv: 'Agora',
        quinzemin: '15m',
        trintamin: '30m',
        umahora: '1h',
        seishoras: '6h',
        dozehoras: '12h',
        vintequatrohoras: '24h',
        quarentaoitohoras: '48h',
        setentaduashoras: '72h',
        noventaseishoras: '96h',
        mes: '1 mês',
        total: 'Total de chuva',
        percent: '% de chuva',
        nfraca: 'Total de fraca',
        nmoderada: 'Total de moderada',
        nforte: 'Total de forte',
        nmuitoforte: 'Total de muito forte',
        mean: 'Média',
        mode: 'Moda',
        median: 'Mediana'
    }

    // multiplicadores das dimensões de tempo.
    // Para a dimensão de 1 hora, temos:
    // Fraca < 2.5 mm / h
    // Moderada < 10 mm / h
    // Forte < 50 mm / h
    // Muito Forte >= 50 mm / h

    // Usando os multiplicadores, conseguimos esses valores para qualquer resolução de tempo. 
    static multipliers: { [key: string]: any } = {
        indice_pluv: 0.25,
        quinzemin: 0.25,
        trintamin: 0.5,
        umahora: 1,
        seishoras: 6,
        dozehoras: 12,
        vintequatrohoras: 24,
        quarentaoitohoras: 48,
        setentaduashoras: 72,
        noventaseishoras: 96,
        mes: 720
    }
}